import React from 'react';
import Select, { Props as SelectProps, GroupBase } from 'react-select';

// Thin typed wrapper over react-select for the DashboardEditor's customer / theme
// / type dropdowns. A single home for react-select config, and it keeps the
// invalid `styles={{ styles }}` prop (removed in Phase 1) from creeping back.
// Generic so each call site still infers its own option shape from `options`.
function DashboardSelect<
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
>(props: SelectProps<Option, IsMulti, Group>) {
  return <Select {...props} />;
}

export default DashboardSelect;
